<template>
  <div class="pulse-indicator-analysis">
    <div class="pulse-card-container">
      <div class="pulse-indicator-table" v-if="indicatorList.length">
        <div class="pulse-table-header">
          <div class="pulse-col pulse-name">项目</div>
          <div class="pulse-col pulse-result">结果</div>
          <div class="pulse-col pulse-normal">参考值</div>
          <div class="pulse-col pulse-status">状态</div>
        </div>
        <div
          class="pulse-table-row"
          v-for="(item, index) in indicatorList"
          :key="`${item.name}-${index}`"
        >
          <div class="pulse-col pulse-name">{{ item.name || '--' }}</div>
          <div class="pulse-col pulse-result">{{ item.result || '--' }}</div>
          <div class="pulse-col pulse-normal">{{ item.normal || '--' }}</div>
          <div class="pulse-col pulse-status" :class="statusClass(item.status)">
            {{ item.status || '--' }}
          </div>
        </div>
      </div>

      <div
        class="pulse-analysis-item"
        v-for="(item, index) in indicatorList"
        :key="`desc-${item.name}-${index}`"
        v-if="item.desc"
      >
        <div class="pulse-analysis-title">{{ item.name }}{{ item.status ? `（${item.status}解读）` : '解读' }}：</div>
        <div class="pulse-analysis-text">{{ item.desc }}</div>
      </div>

      <van-empty v-if="!indicatorList.length" description="暂无指标解析数据" />

      <div class="bottom-statement">
        重要声明：本报告采用AI人工智能分析总结，仅供参考，不可作为医疗诊断结论。如已有身体不适，请及时咨询医生。
        <div class="time-text" v-if="reportData.createAt">生成时间：{{ reportData.createAt }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Empty } from 'vant';

export default {
  name: 'PulseIndicatorAnalysis',
  components: {
    [Empty.name]: Empty
  },
  props: {
    reportData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    indicatorList() {
      const list = this.reportData?.pulseReport?.indicatorAnalysis?.list;
      return Array.isArray(list) ? list : [];
    }
  },
  methods: {
    statusClass(status) {
      const text = status || '';
      if (text.includes('正常')) return 'is-normal';
      if (text.includes('偏高') || text.includes('偏低') || text.includes('中高')) return 'is-warn';
      if (text.includes('异常') || text.includes('较高') || text.includes('高风险')) return 'is-danger';
      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
.pulse-card-container {
  min-height: calc(100vh - 130px);
  background: #fff;
  padding: 24px 16px 32px;
}

.pulse-indicator-table {
  border-top: 1px solid #e3e3e3;
}

.pulse-table-header,
.pulse-table-row {
  display: grid;
  grid-template-columns: 1.1fr 1fr 1.25fr .85fr;
  column-gap: 8px;
  align-items: center;
}

.pulse-table-header {
  min-height: 66px;
  font-size: 15px;
  font-weight: 700;
  color: #333;
  border-bottom: 1px solid #e3e3e3;
}

.pulse-table-row {
  min-height: 74px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #e3e3e3;
}

.pulse-col {
  text-align: center;
  word-break: break-word;
}

.pulse-analysis-item {
  margin-top: 34px;
}

.pulse-analysis-title {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  line-height: 1.6;
}

.pulse-analysis-text {
  margin-top: 8px;
  font-size: 16px;
  line-height: 1.85;
  color: #333;
}

.is-normal {
  color: #13a35d;
}

.is-warn {
  color: #ff7a1a;
}

.is-danger {
  color: #ff2b12;
}

.bottom-statement {
  margin-top: 40px;
  font-size: 13px;
  line-height: 1.7;
  color: #a0a4aa;
}

.time-text {
  margin-top: 8px;
}
</style>
